import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

// Home
import { HomePage } from './pages/home/home';

// Error
import { ErrorPage } from './pages/error/error';
import { LogInV1Page } from './pages/logIn/loginV1';
import { RoleGuard } from './guards/role-guards';
import { PlanProtectionEnTramiteComponent } from './shared/pp-en-tramite/plan-protection-en-tramite';
import { PlanProtectionConsultaComponent } from './shared/pp-consulta/plan-protection-consulta';
import { PlanProtectionCompletarComponent } from './shared/pp-completar/plan-protection-completar.component';
import { ConfirmExitGuard } from './guards/confirm-exit.guard';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomePage, canActivate: [RoleGuard], data: { title: 'Home', expectedRoles: ['Administrador', 'Gerente', 'Promotor', 'Asesor Comercial']} },
  { path: 'pp/consulta', component: PlanProtectionConsultaComponent, canActivate: [RoleGuard], data: { title: 'Consulta Plan Protection', expectedRoles: ['Administrador', 'Gerente', 'Promotor', 'Asesor Comercial']} },
  { path: 'pp/en-tramite', component: PlanProtectionEnTramiteComponent, canActivate: [RoleGuard], data: { title: 'Plan Protection En Trámite', expectedRoles: ['Administrador', 'Gerente', 'Promotor', 'Asesor Comercial']} },
  { path: 'pp/en-tramite/:foliopp', component: PlanProtectionCompletarComponent, canActivate: [RoleGuard], canDeactivate: [ConfirmExitGuard], data: { title: 'Plan Protection En Trámite', expectedRoles: ['Administrador', 'Gerente', 'Promotor', 'Asesor Comercial']} },
  { path: 'LogIn', component: LogInV1Page, data: { title: 'Home'} },
	{ path: '**', component: ErrorPage, data: { title: '404 Error'} }
];

@NgModule({
  imports: [ CommonModule, RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  declarations: []
})


export class AppRoutingModule { }
